import { useEffect } from 'react';
import PersonaVendeForm from '../../components/personal-vende/PersonaVendeForm';
import { useCiudadesStore } from '../../stores/ciudades/ciudades.store';
import { useEstadosStore } from '../../stores/estados/estados.store';
import {
  usePersonalVendeStore,
  type RegistrarPersonaVende
} from '../../stores/personal-vende/personal-vende.store';

const AgregarPersonaVende = () => {
  const { current: persona, nuevo, registrar } = usePersonalVendeStore((state) => state);

  const { actives: ciudades, cargarActivas: cargarCiudades } = useCiudadesStore((state) => state);
  const { actives: estados, cargarActivos: cargarEstados } = useEstadosStore((state) => state);

  useEffect(() => {
    nuevo();
    cargarCiudades();
    cargarEstados();
  }, []);

  const handleSave = (values: RegistrarPersonaVende) => {
    return registrar(values);
  };

  return (
    <PersonaVendeForm
      esAgregar={true}
      persona={persona}
      ciudades={ciudades}
      estados={estados}
      onSave={handleSave}
      reloadCiudades={cargarCiudades}
    />
  );
};

export default AgregarPersonaVende;
